import React from 'react';
import Script from './Script';

export default function CommonRoomScript() {
  return (
    <Script id="common-room-snippet" strategy="afterInteractive">
      {`(function() {
            if (typeof window === 'undefined') return;
            if (typeof window.signals !== 'undefined') return;
            var script = document.createElement('script');
            script.src = 'https://cdn.cr-proxy.com/v1/site/9040dabe-dbc4-422f-8408-62bf265af3a5/signals.js';
            script.async = true;
            window.signals = Object.assign(
              [],
              { _opts: { apiHost: 'https://api.cr-proxy.com' } },
              ['page', 'identify', 'form'].reduce(function (acc, method){
                acc[method] = function () {
                  signals.push([method, arguments]);
                  return signals;
                };
              return acc;
              }, {})
            );
            document.head.appendChild(script);
          })();
        `}
    </Script>
  );
}
